// extracted by mini-css-extract-plugin
export default {"container":"Projects_container__PQxj6","title":"Projects_title__DVb8C","grid":"Projects_grid__G34AL","card":"Projects_card__piAMc"};